import { IExportTieInChartsDTO } from '@interfaces/kpi/dto/kpiDTO';
import { IChart, IChartPoint } from '@interfaces/kpi/kpiCommon';

import { EVendorsValues } from '@enums/common';

import { LOGARITHMIC_MINIMUM_VALUE } from '@constants/KPI/kpi-common';

export const prepareTieInChartToExport = (chart: IChart): IExportTieInChartsDTO => {
	const { aggregationType, from, to, kpiId, sites, vendor, yaxisAggregationType, granularity } = chart;
	const isOranVendor = vendor.name === EVendorsValues.oran;
	const preparedTimeAggregationType = isOranVendor ? undefined : yaxisAggregationType.name;
	const preparedGranularity = isOranVendor ? granularity?.name : undefined;

	return ({
		aggregationType: aggregationType.name,
		from: from,
		to: to,
		kpiId: kpiId,
		sites: sites.map(site => ({ ...site, siteId: site.siteId })),
		timeAggregationType: preparedTimeAggregationType,
		vendor: vendor.name,
		granularity: preparedGranularity,
	});
};

export const prepareChartsWithKpiTags = (charts: IChart[]): IChart[] => {
	return charts.map(chart => {
		const tags = chart.tags?.join(', ').toUpperCase();

		return {
			...chart,
			name: `${chart.name} (${tags})`,
		};
	});
};

export const getLogarithmicLine = (point: IChartPoint) => ({
	...point,
	y: point.y == '0' ? LOGARITHMIC_MINIMUM_VALUE : point.y,
	x: point.x == 0 ? LOGARITHMIC_MINIMUM_VALUE : point.x,
	isZeroValue: point.x == 0 || point.y === '0',
});
